//libs
import { getExperimentVariant } from '@nykaa/experiment-sdk/client';

//helpers
import { getDeviceType } from 'shared/helpers/app';
import { setCookie } from 'shared/helpers/utils';
import { isScriptLoaded } from 'shared/helpers/utils';
import asyncDeferScript, { LOAD_TYPE } from 'shared/helpers/dom/deferScript';

// constants
import { CHECKOUT_COOKIES, CHECKOUT_EXPT_VARIANTS } from 'shared/constants';

export const loadScripts = (scriptDetails: { scriptPath: string; loadType: LOAD_TYPE }[] = []) => {
  scriptDetails.map((scriptInfo) => {
    const { scriptPath, loadType } = scriptInfo;

    if (!isScriptLoaded(scriptPath)) {
      asyncDeferScript(scriptPath, loadType);
    }
  });
};

export const setCheckoutExperimentCookie = () => {
  const isMobile = getDeviceType() === 'MSITE';
  const { isEligible, variant } = isMobile
    ? getExperimentVariant('checkout-ssr-mweb')
    : getExperimentVariant('checkout-ssr-dweb');

  // set pci cookies
  const checkoutPCICookieValue = isEligible && variant === CHECKOUT_EXPT_VARIANTS.PCI ? 1 : 0;
  setCookie(CHECKOUT_COOKIES.PCI, checkoutPCICookieValue, 1);

  // set fcr cookies
  const checkoutFCRCookieName = isMobile ? CHECKOUT_COOKIES.MOBILE : CHECKOUT_COOKIES.DESKTOP;
  const checkoutFCRCookieValue = isEligible && variant === CHECKOUT_EXPT_VARIANTS.FCR ? 1 : 0;
  setCookie(checkoutFCRCookieName, checkoutFCRCookieValue, 1);
};
